/**
 * About component module.
 * @module investor/pages/About
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  Button,
  Column,
  ContactClientServices,
  CopyrightVersion,
  DescriptiveText,
  Image,
  Page,
  Row,
  SocialMedia,
  Tile,
} from '../../shared';
import styled from 'styled-components/macro';
import {icons} from '../../shared/components/Icon';
import {_getPartners} from '../../advisor/reducers/partners';
import {_openModal} from '../../shared/reducers/modals';
import StickyHeaderBar from '../shared/components/StickyHeaderBar';

const _TilesContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: nowrap;
  @media (max-width: 951px) {
    flex-direction: column;
    flex-wrap: wrap;
  }
`;

/**
 * About component
 * @name About
 */
const About = (props) => {
  const {generalDisclosures, openModal} = props;
  const tilesWidth = '100%';
  const tilesHeight = '430px';

  return <Page center={true}>
    <StickyHeaderBar title={'ABOUT'}/>
    <_TilesContainer>
      <Tile key="Security" title="SECURITY" width={tilesWidth} height={tilesHeight} layout={{grow: 1}}>
        <Column height={'100%'} justifySubColumn={'space around'}>
          <CopyrightVersion alignment={'center'} versionTextMargin={'0 0 15px 0'}/>
          {/*ETODO make "Safe and Secure" component?*/}
          <Row wrap={false}>
            {/*TODO Missing Lock Icon! Placeholder*/}
            <Image src={icons.lock} maxHeight={'30px'} maxWidth={'30px'}/>
            <DescriptiveText preset={'bigNumber'}>Safe and Secure</DescriptiveText>
          </Row>
          <DescriptiveText maxWidth={'350px'}>
            We securely protect your information by never storing your credentials and using bank-level encryption for all data
            storage and transfers.
          </DescriptiveText>
          <Button importance={'secondary'}
                  size={'md'}
                  width={'250px'}
                  label={'Security Policy'}
                  action={() => openModal({type: 'SecurityPolicy'})}/>
        </Column>
      </Tile>
      <Tile key="Contact" title="CONTACT" width={tilesWidth} height={tilesHeight} layout={{grow: 1}}>
        <Column height={'100%'} justifySubColumn={'space around'}>
          <ContactClientServices helpTextMargin={'0 0 10px 0'}/>
          <Row wrap={false} alignItems={'top'}>
            <DescriptiveText font={'ProximaSemibold'}
                             fontSize={'18px'}
                             margin={'30px 10px 10px 10px'}
                             alignment={'center'}>
              We Welcome Your Feedback
            </DescriptiveText>
          </Row>
          <Row wrap={false} alignItems={'top'}>
            <DescriptiveText font={'ProximaRegular'}
                             fontSize={'12px'}
                             maxWidth={'350px'}
                             margin={'10px'}
                             alignment={'center'}>
              Please provide us feedback on what works well for you or where you ran into issues,
              as well as what new features you would like to see in the future.
            </DescriptiveText>
          </Row>
          <Row wrap={true} alignItems={'middle'} justifySubRow={'center'}>
            <Column margin={'10px 10px 30px 10px'}>
              <Button importance={'secondary'}
                      size={'md'}
                      width={'250px'}
                      label={'Leave Feedback'}
                      action={() => openModal({type: 'FeedbackModal'})}/>
            </Column>
          </Row>
          <SocialMedia iconsMaxHeight={'40px'} iconsMaxWidth={'40px'} helpTextMargin={'0 0 25px 0'}/>
        </Column>
      </Tile>
      <Tile key="Disclosures" title="DISCLOSURES" width={tilesWidth} height={tilesHeight} layout={{grow: 1}}>
        <Column height={'100%'} justifySubColumn={'space around'}>
          {generalDisclosures
            && <Button importance={'secondary'}
                       size={'md'}
                       width={'250px'}
                       label={'General'}
                       action={() => openModal({
                         type: 'Disclosures',
                         defaultTab: 'general',
                       })}
            />}
          <Button importance={'secondary'}
                  size={'md'}
                  width={'250px'}
                  label={'Privacy Policy'}
                  action={() => openModal({
                    type: 'Disclosures',
                    defaultTab: 'privacyPolicy',
                  })}
          />
          <Button importance={'secondary'}
                  size={'md'}
                  width={'250px'}
                  label={'Terms & Conditions'}
                  action={() => openModal({
                    type: 'Disclosures',
                    defaultTab: 'termsConditions',
                  })}
          />
          <Button importance={'secondary'}
                  size={'md'}
                  width={'250px'}
                  label={'Data Source Partners'}
                  action={() => openModal({
                    type: 'Disclosures',
                    defaultTab: 'dataSourcePartners',
                  })}/>
        </Column>
      </Tile>
    </_TilesContainer>
  </Page>;
};

const mapStateToProps = state => ({
  partners: state.partners,
  generalDisclosures: state.product.brand.generalDisclosures,
});

const mapDispatchToProps = dispatch => ({
  getPartners: () => dispatch(_getPartners()),
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(About);

About.propTypes = {
  openModal: PropTypes.func.isRequired,
  /**
   * The brand's generalDisclosures
   */
  generalDisclosures: PropTypes.string.isRequired,
};
